import styled, { css } from 'styled-components';
import { Table, Input, Select, Modal, DatePicker, Col, Menu, Button } from 'antd';
import {
  DataValue,
  UnderlineLink,
  PagesHeading,
  CommonTable
} from '../../../../CommonComponents/commonStyles';

export const DisplayAlignCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const PrintExport = styled.span`
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #006778;
  text-decoration: underline;
  cursor: pointer;
  margin-right: ${props => props.marginRight};
`;
export const WrapperExtraContent = styled.div`
  padding-top: 12px;
  display: flex;
  align-items: center;
`;

export const BalanceTable = styled(Table)`

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .ant-table-thead > tr > th .ant-table-column-sorter {
    display: inline-block;
    vertical-align: middle;
  }
  .ant-table-tbody > tr > td {
    padding: 16px 10px !important;
  }
}
  .ant-table-row:nth-child(2n + 1) {
    background-color: #f2f2f2 !important;
  }
  .ant-table-thead {
    th {
      background: #ffffff;
      padding: 10px 30px 10px 0px;
    }
  }

  .ant-table-tbody > tr:last-child {
    border-bottom: ${props => props.length%2 === 0 ? "1px solid #ccc" : null};
  }

  .ant-table-tbody > tr > td {
    border: none !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 16px 16px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td:last-child {
    padding: 16px 16px 16px 0px;
  }

  .ant-table-thead
    > tr
    > th
    .ant-table-column-sorter
    .ant-table-column-sorter-inner {
    margin-left: 0px;
  }

  .ant-table {
    font-size: 15px;
  }

  .ant-table-thead
    > tr
    > th
    .ant-table-header-column
    .ant-table-column-sorters {
    display: flex;
  }
`;

export const ColumnHeader = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 15px;
  line-height: 1.5;
  color: #022737;
  width: ${props => (`${props.columnWidth} !important` || 'auto')};  
  .contributionActivitySettledDate {
    padding-right: 10px !important;
  }
  `;

export const ColumnValueFirst = styled.div`
  padding-bottom: ${props => props.paddingBottom};
`;

export const ColumnValues = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.13;
  color: #505050;
`;
export const QueryResult = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  margin: ${props => props.theme.spacing.paddings.webTwiceBase};
  font-weight: ${props => props.theme.fontWeight.bold};
  display: block;
`;

export const Searchbar = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 0px;
`;

export const GrantsSearchContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};  
`;

export const SearchInput = styled(Input.Search)`
  .ant-input {
    border-radius: 0px !important;
  }
`;

export const HiddenFrequency = styled.div`
  visibility: hidden;
  margin: 0px 54px;
`;

export const ContributionSearchLabel = styled.label`
margin-right: 10px;
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.thead};
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-weight: ${props => props.theme.fontWeight.normal};
margin-left: ${props =>
  props.marginLeft === undefined ? '0px' : props.marginLeft};
line-height: 40px;
`;

export const SelectTab = styled(Select)`
  width: 200px;
  border: 1px solid transparent;
  .ant-select-dropdown {
    top: 118px !important;
  }

  .ant-select-selection {
    border-radius: 0px;
  }

  &:hover,
  &:focus {
    border: 1px solid #f2f2f2 !important;
    background-color: #f2f2f2 !important;
  }

  .ant-select-selection:hover,
  .ant-select-selection:focus,
  .ant-select-selection:active,
  .ant-selection-select.active,
  .ant-select-focused,
  .ant-select-enabled,
  .ant-select-open .ant-select-enabled,
  .ant-select-focused .ant-select-selection {
    border: 1px solid #d9d9d9;
    box-shadow: none !important;
  }

  .ant-select-selection--multiple {
    cursor: unset;
  }

  .ant-select-selection--multiple
    .ant-select-search--inline
    .ant-select-search__field {
    color: transparent;
  }

  .ant-select-selection--multiple .ant-select-selection__rendered {
    height: 40px;
    margin-bottom: -5px;
    margin-left: 20px;
  }

  .ant-select-selection--multiple .ant-select-selection__placeholder {
    color: #d4d4d4;
    font-size: 16px;
    margin-left: 0 !important;
    margin-top: -12px !important;
    font-family: HelveticaNeue;
  }

  .ant-select-selection--multiple .ant-select-selection__choice {
    max-width: 85%;
    color: ${props => props.theme.fontColors.thead}
  }

  .ant-select-arrow {
    top: 0;
    color: #606060;
    padding: 16px 13px;
    background-color: #f5f5f5;
    margin: 1px 1px;
    right: 0;
    bottom: 0;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 160px;
  }
`;

export const PickTimeFrame = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const CustomModal = styled(Modal)`
  .ant-modal-footer {
    display: flex;
    justify-content: center;
  }
  .ant-modal-footer > * {
    width: 200px;
  }

  .ant-calendar-input-wrap {
    border: none;
  }

  .ant-modal-body {
    padding: 30px 10px 24px 10px
  }

  .ant-modal-content {
    border-radius: 0;
  }

  .ant-modal-content .ant-modal-close-x {
    font-size: ${props => props.theme.fontSize.h5};
    color: ${props => props.theme.fontColors.textColor};
    width: 68px;
    line-height: 68px;
  }

  .ant-modal-footer {
    border: none !important;
    padding: 0 10px 30px 10px;
  }

  .ant-modal-footer button {
    flex: none;
    padding: 0;
    
  }
  
  @media only screen and (max-width: 320px) {
    width: calc(100vw - 40px) !important;
    margin: 0 auto !important;
    .ant-modal-footer button {
      width: 93px;
    }
  }
  top: 70px;
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    width: calc(100vw - 50px) !important;
    margin: 0 auto !important;
    .ant-modal-footer button {
      width: 113px;
    }
  }

  @media only screen and (min-width: 376px) and (max-width: 425px) {
    width: calc(100vw - 54px) !important;
    margin: 0 auto !important;
    .ant-modal-footer button {
      width: 131px;
    }
  }

`;

export const CustomDatePicker = styled(DatePicker.RangePicker)`
  .ant-calendar-picker-container {
    left: 453px;
    top: 440px;
    .activityMobileWrapper .ant-calendar {
      width: 260px;
    }
  }
  .ant-calendar-range {
    left: -20px;
  }
  .ant-calendar-range {
    left: -20px;
  }
  & .ant-calendar-date-input-wrap {
    margin-left: 100px !important;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    .ant-calendar-picker-container {
      left: 55px;
      top: 0;
    }
  }
`;

export const ClearTime = styled.div`
  position: relative;
  float: left;
  max-width: 100%;
  line-height: 30px;
  height: 30px;
  margin: 4px 2px;
  cursor: pointer;
  padding: 0 10px 0 10px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;

export const ClearTimeMob = styled.div`
  position: relative;
  float: left;
  max-width: 100%;
  line-height: 30px;
  height: 30px;
  margin: 4px 2px;
  padding: 0 10px 0 10px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  cursor: default;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    color: ${props => props.theme.fontColors.textColor};
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TimeFrame = styled.div`
  width: 200px;
  height: 40px;
  border-radius: 0px;
  border: 1px solid #d4d4d4;
  line-height: 40px;
  padding-left: 20px;
  background: white;
  font-size: 16px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: #d4d4d4;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 68% !important;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TimeFramed = styled.div`
  height: 40px;
  border-radius: 0px;
  border: 1px solid #d4d4d4;
  line-height: 40px;

  background: white;
  font-size: 14px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  color: #d4d4d4;
`;

export const DateWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  background: white;
  height: 306px;
  & > div:first-of-type {
    position: static !important;
    width: unset !important;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 302px;
  }

  `;

export const UnderLinkButton = styled(UnderlineLink)`
  width: 60%;
  margin: 0 auto;
`;

export const TableData = styled(DataValue)`
  font-family: ${props => props.theme.fontFamily.HelveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
`;

export const GrantsActivityContent = styled(DataValue)`
  margin-top: 0px;
  padding-bottom: 20px;
`;

const commonFontStyles = css`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  letter-spacing: 0.5px;
  color: #505050;
`;

export const TabName = styled.span``;

export const TabsWrap = styled.div`
  .ant-tabs-bar {
    /* border-bottom: none; */
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    height: 55px;
    padding: 0 20px;
    margin-right: 0;
    border-radius: 0;
    line-height: 54px;
    background: #f4f3f3;
    ${commonFontStyles};
    border-top: 4px solid rgba(0, 103, 120, 0.1);
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 56px;
    ${commonFontStyles};
    color: #006778;
    background: #ffffff;
    border-top: 4px solid #006778;
  }
  .ant-tabs-nav-container-scrolling {
    padding: 0;
  }
  .ant-tabs-tab-arrow-show {
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
  }
`;

export const IconWrap = styled.div`
  display: flex;
  margin-right: ${props => props.marginRight};
  i {
    svg {
      width: 27px;
      height: 18px;
    }
  }
`;

export const ContributionContentWrapper = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #505050;
  margin-bottom: 21px;
  max-width: 963px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    line-height: 1.43;
    margin-bottom: 40px;
  }
`;

export const DataHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-size: 14px;
  font-style: normal;
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
`;

export const BoldFont = styled.div`
  font-family: HelveticaNeue-Bold, Helvetica, Arial, sans-serif;
`;

export const DataVal = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 14px;
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  color: #505050;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const FilterIconWrapper = styled.div`
  height: 40px;
  width: 81px;
  border: solid 1px #d4d4d4;
  margin-left: auto;
  margin-right: 0;
  margin-bottom: 20px;
  margin-top: 20px;
`;
export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 10px;
  .ant-tooltip {
    max-width: 260px !important;
  }
`;
export const TooltipWrapper = styled.div`
  .ant-tooltip-inner {
    background-color: #ffffff !important;
  }
`;

export const ViewPillButton = styled(Button)`
color: #006778;
font-size: 14px;
border-radius: 18px;
box-shadow: 0;
padding : 6px 35px;
&& {
.ant-btn {
  height: auto !important;
}
}

&:hover, &:focus{
  color: #006778 !important;
  border: 1px solid #d4d4d4 !important;
  background-color: #ffffff !important;
}
font-family: HelveticaNeue-Medium;
`;

export const ContributionsUnderlineLink = styled(UnderlineLink)`
  position: relative;
  left: 2px;
  top: 3px;
  font-family: HelveticaNeue;
  padding-left:20px;
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const ExportPrint = styled.span`
  font-family: HelveticaNeue-Medium;
  font-size: 16px;
  letter-spacing: 0.5px;
  color: #006778;
  text-decoration: underline;
  cursor: pointer;
  margin-right: ${props => props.marginRight};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 16px;
  }
`;

export const ExtraContentWrap = styled.div`
  padding-top: 12px;
  display: flex;
  align-items: center;
`;

export const ContributionActivityText = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #505050;
  margin-top: 30px;
  margin-bottom: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    line-height: 1.43;
    margin-top: 20px;
    margin-bottom: 40px;
  }
`;

export const AccountIdWrapper = styled.div`
  font-family: HelveticaNeue-bold;
  font-size: 24px;
  color: #505050;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    overflow: hidden;
    font-size: 20px;
    line-height: 1.17;
    word-break: break-all;
  }
`;
export const FundNameWrapper = styled.div`
  font-family: HelveticaNeue;
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  color: #505050;
  word-break: break-word;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: break-all;
  }
`;
export const ContributionActivityHeading = styled(PagesHeading)`
  margin-bottom: 30px;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 36px;
    line-height: 1.17;
    margin-bottom: 22px;
  }
`;

export const UnderlineLinkB = styled.a`
  font-family: ${props => props.theme.fontFamily.HelveticaNeue};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.primary} !important;
  text-decoration: underline;
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;

export const IconsPlaceNew = styled.div`
  text-align: right;
  > span > button {
    padding-right: 30px;
  }
  @media (max-width: 576px) {
    > span > button {
      padding-right: 5px;
    }
  }
  @media (max-width: 990px) {
    text-align: initial;
    transform: initial;
    margin-bottom: 20px;
  }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: ${props => (props.primary ? '50px' : '')};
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 20px;
    margin-top: 15px;
  }
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    letter-spacing: ${props => props.theme.letterSpacing.zero};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SelectTabsWrapper = styled.div`
  .ant-tabs-bar {
    margin: 0;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    border-bottom: 1px solid ${props => props.theme.colors.border};

    .ant-tabs-nav {
      /* border-left: 1px solid #bfbfbf;
      border-right: 1px solid #bfbfbf; */
    }

    .ant-tabs-nav-container {
      height: 55px !important;
    }
  }

  .ant-tabs-tab:hover {
    color: unset;
  }

  .ant-tabs.ant-tabs-card {
    .ant-tabs-card-bar {
      .ant-tabs-tab {
        margin-right: 0;
        border: none;
        padding-left: 0;
        padding-right: 0;
        border-top: 4px solid rgba(0, 103, 120, 0.1);
        height: 56px;
        border-bottom: 1px solid #d4d4d4;
      }

      .ant-tabs-tab-active {
        border-left: 1px solid #d4d4d4;
        border-right: 1px solid #d4d4d4;
        color: #006778;
        border-top: none;
        font-weight: ${props => props.theme.fontWeight.normal};
        border-top: 4px solid #006778 !important;
        height: 56px;
        border-bottom: none;
        background-color: #ffffff !important;
        min-width: 178px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .ant-tabs-tab {
    font-family: HelveticaNeue-Bold;
    font-size: 16px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    text-align: center;
    background-color: #d4d4d4 !important;
    border-radius: 0 !important;
    border-right: 1px solid #d4d4d4 !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
      letter-spacing: 0.5px;
    }
  }
`;

export const FlexAccount = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const PrintExportBtn = styled(Col)`
  float: right;
  transform: translate(3px, 46px);
  z-index: 10;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    float: none !important;
    transform: translate(0, 0) !important ;
    z-index: 10;
  }
`;

export const CalenderClear = styled.span`
  cursor: pointer;
  padding-right: 5px;
  padding-left: 3px;
`;

export const FixedWidth = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  margin-bottom: -30px;
  @media (max-width: 1440px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 576px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const ActivityFixedWidth = styled(FixedWidth)`
  max-width: 1112px;
  margin: 0;
  padding: 0;
  @media (max-width: 1440px) {
    padding: 0;
  }
  @media (max-width: 576px) {
    padding: 0;
  }
`;

export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FilterButton = styled.div`
  margin: 20px 0px;
  border: 1px solid #d4d4d4;
  color: ${props => props.theme.colors.tabHead};
  display: flex;
  width: 80px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
`;

export const FilterArrow = styled.div`
  position: absolute;
  top: 120px;
  width: 0;
  right: 41px;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 8px solid #d5d5d5;
  background-color: transparent;
`;

export const FilterWrappered = styled.div`
  position: absolute;
  top: 128px;
  right: 0;
  left: 0;
  border: 1px solid #d5d5d5;
  z-index: 100;
`;

export const SelectWrapper = styled.div`
  .ant-select-dropdown {
    top: 118px !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      top: 62.3px !important;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 68% !important;
  }

  .ant-select-selection--multiple {
    .ant-select-selection__rendered{
      margin-left: 20px !important;
    }

}
  
`;

export const EmptyMessage = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.tableFont};
`;

export const UnderlineButton = styled.a`
  ${({ center }) =>
    center &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `}
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 16px;
  padding-left: 0px !important;
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  color: ${props => props.theme.fontColors.primary} !important;
  text-decoration: underline;
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;

export const StyledMenu = styled(Menu)`
  border:1px solid #eee;
  && .ant-menu-item {
    height: 65px;
    padding: 10px;
    border: 1px solid #bfbfbf;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  }
  .ant-menu-vertical {
    height: auto;
  }
  .ant-menu-item {
    height: auto;
  }
`;

export const AccountSummary = styled.div`
font-size:${props => props.theme.fontSize.primary};
color:  ${props => props.theme.fontColors.textColor};
font-family: ${props => props.theme.fontFamily.helveticaNeue};
  display: flex;
  flex-direction:column !important;

  .ant-divider:last-child {
    display: none;
  }
  @media only screen and (max-width: 560px) {
    flex-direction: column;
  }
`;

export const ActivityTable = styled(CommonTable)`
  ${ViewPillButton}{
    padding: 6px 18px;
  }
  table{
    th,td{
      word-wrap: break-word;
    }    
  }
  &.contributionActivityTable .ant-table-fixed-header .ant-table-scroll, 
  &.contributionActivityTable .ant-table-body {
    border-top: 1px solid #eaeaea !important;
  }
  .ant-table-tbody > tr > td:last-child { 
    padding: 10px 16px 10px 10px; 
  }
  .ant-table-thead > tr > th .ant-table-column-sorter {
    display: inline-block;
    vertical-align: middle;
    position: absolute; 
    left: 2px;
  }
  .ant-table-thead
    > tr
    > th
    .ant-table-column-sorter
    .ant-table-column-sorter-inner {
    margin-left: 0px;
  }
  .ant-table-thead
    > tr
    > th
    .ant-table-header-column
    .ant-table-column-sorters {
    display: flex;
  }
  .ant-table-column-title {
    transform: translate(0px, 0px) !important;  
  }
`;

export const ClosedIcon = styled.img``;
export const DisplayValue = styled.div``;
export const AlignCenter = styled.div`
width : ${props => props.columnWidth || 'auto'}
text-align: center;
`;
export const LoadButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 35px;
  && button {
    min-width: 150px;
  }
`;